import {viewTransition} from '$c3local/view-transition.js';

export function initJobList() {
    const jobList = document.querySelector('.job-list');
    if (!jobList) {
        return;
    }

    /** @type {HTMLFormElement} */
    const filter = jobList.querySelector('.job-list-filter');
    const items = jobList.querySelectorAll('.job');
    /** @type {{element: HTMLElement, properties: {areas: number[], level: number, title: string}}[]} */
    const jobs = [];
    for (const job of items) {
        jobs.push({
            element: job,
            properties: JSON.parse(job.dataset.properties),
        });
    }

    filter.addEventListener('submit', e => e.preventDefault());

    filter.addEventListener('change', () => {
        /** @type {string} */
        const search = new FormData(filter).get('search');
        /** @type {number} */
        const level = parseInt(/** @type {string} */ new FormData(filter).get('level'));
        /** @type {number} */
        const area = parseInt(/** @type {string} */ new FormData(filter).get('area'));

        viewTransition(() => {
            for (const job of jobs) {
                if (search && !job.properties.title.includes(search.toLowerCase())) {
                    job.element.hidden = true;
                    continue;
                }

                if (level && job.properties.level !== level) {
                    job.element.hidden = true;
                    continue;
                }

                if (area && !job.properties.areas.includes(area)) {
                    job.element.hidden = true;
                    continue;
                }

                job.element.hidden = false;
            }
        });
    });
}